import { useNavigate } from 'react-router';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../ui/card';
import { RecentActivityItem } from './RecentActivityItem';
import { RecentActivity } from '../../services/metricsService';

interface RecentActivityCardProps {
  activities: RecentActivity[];
}

export function RecentActivityCard({ activities }: RecentActivityCardProps) {
  const navigate = useNavigate();

  const handleActivityClick = (activity: RecentActivity) => {
    const { type, fund_id, entity_id } = activity;
    switch (type) {
      case 'capital_call':
        if (fund_id) {
          navigate(`/app/funds/${fund_id}?tab=transactions&section=drawdowns`, {
            state: { highlightDrawdownId: entity_id },
          });
        } else {
          navigate('/app/capital-calls');
        }
        break;
      case 'distribution':
        if (fund_id) {
          navigate(
            `/app/funds/${fund_id}?tab=transactions&section=distributions`,
            {
              state: { highlightDistributionId: entity_id },
            }
          );
        }
        break;
      case 'valuation':
        navigate(
          entity_id
            ? `/app/portfolio/${entity_id}?section=valuations`
            : '/app/portfolio'
        );
        break;
      default:
        console.error('Unknown activity type:', type);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Activity</CardTitle>
        <CardDescription>Latest fund operations and updates</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {activities.length > 0 ? (
            activities.map((activity) => (
              <RecentActivityItem
                key={activity.id}
                activity={activity}
                onClick={handleActivityClick}
              />
            ))
          ) : (
            <div className="text-center py-6">
              <p className="text-sm text-muted-foreground">
                No recent activity to display
              </p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
